export function getSchoolSlug() {
  return localStorage.getItem("school_slug");
}

export const getUserType = () => {
  const parts = localStorage.getItem("previousPathname")?.split("/");
  return parts.length > 0 ? parts[1] : null;
};
